module.exports = __webpack_public_path__ + "img/8-1.88b475b4.svg";